import { useRouter } from "next/router";
import { useEffect } from "react";
import { useStore } from "../store";

export const useUpdateStoreFromURI = () => {
  const store = useStore();
  const { query } = useRouter();
  useEffect(() => {
    store.setQuickFilterFromURL(query);
    store.where.fromURLSearchParam(query);
    store.orderBy.fromURLSearchParam(query);
    store.pagination.fromURLSearchParam(query);
  }, []);
};
